module.exports = __webpack_public_path__ + "static/media/location-img.0e40120c.svg";